import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

import Header_Company from '../../Components/Header_Company';
import Company_Agent from '../../Components/CompanyDetails/Company_Agent';
import Company_Supervisor from '../../Components/CompanyDetails/Company_Supervisor';

const Company_Team = () => {
  const [activeTab, setActiveTab] = useState('supervisor'); // Default tab

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("user");

    if (!storedUserData) {
      Swal.fire("Error", "No user data found in sessionStorage.", "error");
    }
  }, []);

  return (
    <div className="container-fluid">
      <Header_Company />

      {/* Tabs */}
      <ul className="nav nav-tabs mt-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'supervisor' ? 'active' : ''}`}
            onClick={() => setActiveTab('supervisor')}
          >
            Company_Supervisor
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'agent' ? 'active' : ''}`}
            onClick={() => setActiveTab('agent')}
          >
            Company_Agent
          </button>
        </li>
      </ul>

      {/* Tab Content */}
      <div className="tab-content mt-4">
        {activeTab === 'supervisor' && (
          <div className="tab-pane fade show active">
            <Company_Supervisor />
          </div>
        )}
        {activeTab === 'agent' && (
          <div className="tab-pane fade show active">
            <Company_Agent />
          </div>
        )}
      </div>
    </div>
  );
};

export default Company_Team;